import Middleware from "../../utils/api-middleware"
import api from "../../utils/axios-util";


// export const TicketHistory = (data) => {
//     return (dispatch, getState) => {
//         return new Promise(async (resolve, reject) => {
//             await api
//                 .get(`/ticketshistory/fetch?skip=${data.skip}&take=${data.take}&ticket_id=${data.ticket_id}`)
//                 .then((response) => {
//                     resolve(response);
//                 })
//                 .catch((err) => {
//                     reject(err);
//                 });
//         });
//     };
// };

export const CreateTicketNote = (data) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/ticket/notelog/create`, data)
                .then((response) => {
                    let res = Middleware("tickets", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const SendTicketEmail = (data) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/mailsend`, data)
                .then((response) => {
                    let res = Middleware("tickets", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const TicketCustomformFields = () => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/ticketsfields/fetch`)
                .then((response) => {
                    let res = Middleware("tickets", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const TicketStatus = () => {
    return () => {
        return new Promise(async (resolve, reject) => {
            const filter = {
                status: 'status=Active'
            }
            await api
                .get(`/ticketstatus/fetch?${filter.status}`)
                .then((response) => {
                    let res = Middleware("tickets", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "fetch", err.response.data, "catch")
                    reject(res);
                });
        })
    }
}


export const TicketFetch = (url) => {

    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            let teamdata = JSON.parse(localStorage.getItem("Teaminfo"))
            let channel = []
            if (Object.keys(teamdata).length > 0) {
                if (teamdata.type == "all" || teamdata.type == "channel") {
                    channel = teamdata.type_data.channel.map((elm) => elm.name)
                }
            }
            await api
                .post(url, { channel: channel })
                .then((response) => {
                    let res = Middleware("tickets", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};




export const TicketUpdate = (ticket_id, payload) => {
    payload.ticket_id = ticket_id
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .put(`/tickets/update`, payload)
                .then((response) => {
                    let res = Middleware("tickets", "update", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "update", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const TicketGetRequestModule = (phone, template) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/fetch/requestmodule?phone_number=${phone}&template_name=${template}`)
                .then((response) => {
                    let res = Middleware("tickets", "fetch", response)
                    console.log(res, "ffffffffffffffffff");

                    if (res.statusCode === 200) {
                        dispatch({
                            type: 'CUSTOM_TICKET_REQ_MODULE',
                            payload: response.data
                        })
                        resolve(res);
                    } else {
                        dispatch({
                            type: 'CUSTOM_TICKET_REQ_MODULE',
                            payload: []
                        })
                        resolve(res);
                    }
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const TicketCreate = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/tickets/create`, payload)
                .then((response) => {
                        let res = Middleware("tickets", "create", response)
                        resolve(res);
                    })
                    .catch((err) => {
                        let res = Middleware("ticketns", "create", err.response.data, "catch")
                        reject(res);
                    });
        });
    };
};


export const TicketTagManagement = () => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/tags/fetch`)
                .then((response) => {
                    let res = Middleware("tickets", "fetch", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "fetch", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};


export const TicketMerge = (payload) => {
    payload.portal = "false"
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/tickets/merge`, payload)
                .then((response) => {
                    let res = Middleware("tickets", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};

export const TicketDeMerge = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .post(`/tickets/unmerge`, payload)
                .then((response) => {
                    let res = Middleware("tickets", "create", response)
                    resolve(res);
                })
                .catch((err) => {
                    let res = Middleware("ticketns", "create", err.response.data, "catch")
                    reject(res);
                });
        });
    };
};
